import React from "react";
import { Button, message } from "antd";
import LoginForm from "./loginForm.js";
import RecoverLogin from "./recoverLogin.js";
import styles from "./login.module.css";
import "./login.css";

// Internet Explorer 6-11
const isIE = /*@cc_on!@*/false || !!document.documentMode;

// Edge 20+
//const isEdge = !isIE && !!window.StyleMedia;

class LoginSlide extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      recoverWindowVisible: false
    };

    this.handleRecoverClick = this.handleRecoverClick.bind(this);
    this.handleOk = this.handleOk.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleLoginFormValues = this.handleLoginFormValues.bind(this);
    this.handleRecoverFormValues = this.handleRecoverFormValues.bind(this);
  }


  handleLoginFormValues = e => {
    var request = { User: e.userName, Password: e.password };
    this.props.login(request);
  };

  handleRecoverFormValues = e => {
    console.log("form values: ", e);
    this.props.recoverPassword(e.name).then(
      result => {
        if (result) {
          //!!!!! При таком способе восстановления пароля. Пароль может быть сброшен любым пользователем
          //для другого пользователя, который получит его на свою почту (и может об этом не узнать).
          //Нормально отправлять промежуточный код восстановления на почту и по промежуточной ссылке 
          //сбрасывать пароль.
          message.success("На Вашу почту отправлен новый пароль.");
        }
        else {
          message.success("Автоматически восстановить пароль не удалось. Для восстановления пароля обратитесь в службу поддержки.");
        }
      },
      error => {
        message.error("Ошибка при отправке заявки на восстановление пароля.");
      }
    );
    //message.success("Заявка успешна отправлена");
  };

  handleRecoverClick(e) {
    e.preventDefault();

    this.setState(state => {
      return { recoverWindowVisible: true };
    });
  }

  handleOk = e => {
    //console.log("OK handled");
    //console.log(e);

    this.setState(state => {
      return { recoverWindowVisible: false };
    });
  };

  handleCancel = e => {
    this.setState(state => {
      return { recoverWindowVisible: false };
    });
  };
  render() {
    let isFromMainSlide = false;
    if (
	  this.props.location && 
      typeof this.props.location.state !== "undefined" &&
      typeof this.props.location.state.source !== "undefined"
    ) {
      isFromMainSlide =
        this.props.location.state.source === "mainSlide" ? true : false;
    }

    return (
      <div className={styles.container}>
        <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
          <div style={{ flex: "11" }}>
            <div
              style={{
                fontSize: "0.88vw",
                paddingLeft: "1.5em",
                backgroundColor: "#2679bd",
                fontWeight: "600",
                color: "white",
                paddingBottom: "0.5em",
                paddingTop: "0.5em",
                borderRadius: "6px 6px 0px 0px"
              }}>
              <span style={{ fontSize: "1.15vw" }}>ВХОД В ЛИЧНЫЙ КАБИНЕТ</span>
            </div>
          </div>
          <div style={{ flex: "1" }} />
          <div style={{ flex: "18" }} />
        </div>

        <div style={{ display: "flex", width: "100%" }}>
          <div style={{ flex: "11" }}>
            <div className={styles.loginFormContainer}>
              <div className="formWrapper formWrapperInline"
                style={{ paddingTop: "1em", paddingBottom: "1em" }}>
                <LoginForm
                  submitHandler={this.handleLoginFormValues}
                  fromMainSlide={isFromMainSlide} />
              </div>
				  <div style={{ paddingBottom: "1.4em", display: (isIE ? 'none' : 'block') }}>
					<a
					  href="#"
					  onClick={this.handleRecoverClick}
					  style={{
						paddingLeft: "20.83333333%",
						textDecoration: "underline"
					  }}
					>
					  Восстановить мой пароль
					</a>
				  </div>
              <RecoverLogin
                okHandler={this.handleOk}
                cancelHandler={this.handleCancel}
                isVisible={this.state.recoverWindowVisible}
                submitHandler={this.handleRecoverFormValues}
              />
            </div>
          </div>
          <div style={{ flex: "1" }} />
          <div style={{ flex: "18" }}>
            <div style={{ fontWeight: "600", fontSize: "1.07vw" }}>
              В поле «Имя» нужно ввести:
            </div>
            <div style={{ paddingTop: "0.8vh" }}>
              <ul className="globalLoginUlList">
                <li style={{ display: "list-item" }}>
                  Для абонентов - номер, например «0818/086»
                </li>
                <li style={{ display: "list-item" }}>
                  Для обслуживающих организаций - наименование организации,
                  например «Энергомер»
                </li>
              </ul>
            </div>

            <div style={{ paddingTop: "4.5vh" }}>
              <Button
                className="roundButton"
                onClick={this.props.demoEnter}
                type="primary"
              >
                ДЕМО-ДОСТУП
                </Button>
            </div>
            <br />
            <div style={{ textAlign: "center", width:"25%" }}>
                <a href="Documents/Руководство по эксплуатации АСУТ-601М2.pdf" target="_blank"> Скачать руководство <br />ИС "Теплоинформ"</a>
            </div>
          </div>
        </div>
      </div >
    );
  }
}

export default LoginSlide;
